import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { 
  Form, 
  Input, 
  Button, 
  Card, 
  Alert, 
  Typography, 
  Row, 
  Col,
  Space
} from 'antd';
import { UserOutlined, LockOutlined, LoginOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';

const { Text } = Typography;

const LoginPage = () => {
  const [form] = Form.useForm();
  const { login, isAuthenticated, isLoading, error, clearError } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Limpar erros quando o componente é montado
  useEffect(() => {
    clearError();
  }, [clearError]);

  // Redirecionar se já estiver autenticado
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }
  const handleSubmit = async (values) => {
    try {
      if (values.username && values.password) {
        setIsSubmitting(true);
        clearError();

        const result = await login({
          username: values.username,
          password: values.password
        });

        if (!result.success) {
          // O erro já foi definido no contexto
          form.setFields([
            {
              name: 'password',
              errors: ['']
            }
          ]);
        }
      }
    } catch (error) {
      console.error('Erro no login:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFieldChange = () => {
    // Limpar erros quando o usuário começar a digitar
    if (error) {
      clearError();
    }
  };  return (
    <div style={{ 
      minHeight: '100vh',
      backgroundImage: 'url("/img/banner-geral.png")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <Row justify="center" style={{ width: '100%', maxWidth: '400px' }}>
        <Col span={24}>          <Card            style={{
              borderRadius: '12px',
              boxShadow: '0 20px 40px rgba(0,0,0,0.5)',
              border: 'none',
              backgroundColor: '#000000'
            }}
            bodyStyle={{ padding: '40px' }}
          ><div style={{ textAlign: 'center', marginBottom: '32px' }}>
              <div style={{ marginBottom: '16px' }}>                <img 
                  src="/img/logo.png" 
                  alt="DSIACData Logo" 
                  style={{ 
                    borderRadius: '10px', 
                    maxWidth: '140px', 
                    height: 'auto' 
                  }} 
                />
              </div>
            </div>

            {error && (
              <Alert
                message={error}
                type="error"
                showIcon
                style={{ marginBottom: '24px' }}
                closable
                onClose={clearError}
              />
            )}            <Form
              form={form}
              name="login"
              onFinish={handleSubmit}
              onFieldsChange={handleFieldChange}
              size="large"
              layout="vertical"
              validateTrigger={['onBlur', 'onChange']}
            ><Form.Item
                name="username"
                label={<span style={{ color: '#ffffff' }}>Usuário ou Email</span>}
                rules={[
                  {
                    required: true,
                    message: 'Por favor, insira seu usuário ou email!'
                  }
                ]}
                validateTrigger={['onBlur', 'onChange']}
              ><Input
                  prefix={<UserOutlined style={{ color: '#555555' }} />}
                  placeholder="Digite seu usuário ou email"
                  autoComplete="username"
                  style={{ backgroundColor: '#ffffff', color: '#333333', borderColor: '#e0e0e0' }}
                />
              </Form.Item>              <Form.Item
                name="password"
                label={<span style={{ color: '#ffffff' }}>Senha</span>}
                rules={[
                  {
                    required: true,
                    message: 'Por favor, insira sua senha!'
                  }
                ]}
                validateTrigger={['onBlur', 'onChange']}
              ><Input.Password
                  prefix={<LockOutlined style={{ color: '#555555' }} />}
                  placeholder="Digite sua senha"
                  autoComplete="current-password"
                  style={{ backgroundColor: '#ffffff', color: '#333333', borderColor: '#e0e0e0' }}
                />
              </Form.Item>

              <Form.Item style={{ marginBottom: '16px' }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isSubmitting || isLoading}
                  block
                  icon={<LoginOutlined />}
                  style={{
                    height: '48px',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: '500'
                  }}
                >
                  {isSubmitting ? 'Entrando...' : 'Entrar'}
                </Button>
              </Form.Item>
            </Form>

            <div style={{ textAlign: 'center', marginTop: '24px' }}>              <Space direction="vertical" size="small">
                <Text style={{ fontSize: '12px', color: '#cccccc' }}>
                  Sistema de gerenciamento de conteúdo
                </Text>
                <Text style={{ fontSize: '12px', color: '#cccccc' }}>
                  © 2024 DSIACData
                </Text>
              </Space>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default LoginPage;
